import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-modal',
  templateUrl: './terms-noel-modal.component.html',
  styleUrls: ['./terms-noel-modal.component.scss']
})
export class TermsNoelModalComponent implements OnInit {

  constructor(private matDialogRef: MatDialogRef<TermsNoelModalComponent>) { }

  ngOnInit() {
  }

  closeModal() {
    this.matDialogRef.close();
  }

}
